<template>
  <v-system-bar dark color="#3c3c3c" class="titlebar">
    <img src="../assets/so_logo30.png" />
    <div class="bar1">
      <div class="dragregion">
        <slot></slot>
        <span style="font-size: 1.2em">{{ title }} - {{ VERSION }}</span>
        <v-spacer></v-spacer>
      </div>
      <div
        class="button"
        @click="setModalConfig(true)"
        v-if="user.edita_config"
      >
        <span class="dash">
          <v-icon dark small>mdi-cog</v-icon>
        </span>
      </div>
      <div class="button" @click="onMinimize">
        <span class="dash">
          <v-icon>mdi-minus</v-icon>
        </span>
      </div>
      <div class="button" @click="onMaximize">
        <span class="dash">
          <v-icon>mdi-checkbox-blank-outline</v-icon>
        </span>
      </div>
      <div class="button close1" @click="onClose">
        <span class="dash">
          <v-icon>mdi-close</v-icon>
        </span>
      </div>
    </div>
  </v-system-bar>
  <!-- <div class="titlebar">
    <img src="../assets/so_logo30.png" />
    <div class="bar">
      <slot></slot>
      <div class="dragregion">
        <span>{{title}}</span>
      </div>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn dark v-on="on">
            <v-icon>mdi-account</v-icon>Status
            <relogio :datainicial="new Date()"></relogio>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in user.filas" :key="index">
            <v-list-item-title>
              <v-switch
                v-model="filaStatus[index].value"
                :label="item.fila"
                color="success"
                :value="true"
                hide-details
                @click="queueEvent(filaStatus[index])"
              ></v-switch>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="button" @click="onConfig">
        <span class="dash">
          <v-icon dark small>mdi-cog</v-icon>
        </span>
      </div>
      <div class="button" @click="onMinimize">
        <span class="dash">&#x2012;</span>
      </div>
      <div class="button" @click="onMaximize">
        <span>&#9744;</span>
      </div>
      <div class="button close" @click="onClose">
        <span>&#10005;</span>
      </div>
    </div>
    <conn-config :open="config" :cancel="cancel" v-on:update:open="config = $event"></conn-config>
  </div>-->
</template>
   
<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
import swal from "sweetalert2";
export default {
  name: "titleBar",
  props: ["title", "ico"],
  components: {},
  data: () => ({
    cancel: true,
    config: false,
    filaStatus: [],
    VERSION: require("../../package.json").version,
  }),
  created() {
    //remote.webContents.setZoomFactor(1);
  },
  mounted() {},
  computed: {
    ...mapState("auth", {
      user: (state) => state.user,
      isLogged: (state) => state.isLogged,
    }),
    configLocal() {
      return localStorage.getItem(`config`);
    },
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.filaStatus = newValue.filas;
      }
    },
  },
  methods: {
    ...mapActions("auth", ["queueAdd", "queueRemove", "queuePause"]),
    ...mapActions("xc", ["setModalConfig"]),

    onClose() {
      if (this.isLogged) {
        swal
          .fire({
            title: `${this.t("fraseAoFechar1")}`,
            text: `${this.t("fraseAoFechar2")}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: `${this.t("cancelar")}`,
            confirmButtonText: `${this.t("ok")}`,
          })
          .then(async (result) => {
            if (result.value) {
              for (let fila of this.user.filas) {
                this.queueRemove({ data: fila, user: this.user });
              }
              if (
                this.$store.state.sip &&
                this.$store.state.sip.status &&
                this.$store.state.sip.status === "connected"
              ) {
                await this.$store._vm.$WebPhone.client.close();
              }
              //close();
            }
          });
      } else {
      }

      //close();
    },
    queueEvent(data) {
      setTimeout(() => {
        if (data.value) {
          this.queueAdd({ data: data, user: this.user });
        } else {
          this.queueRemove({ data: data, user: this.user });
        }
      }, 500);
    },
    onConfig() {
      this.config = true;
    },
    onMinimize() {},
    onMaximize() {},
  },
};
</script>

<style scoped>
.titlebar {
  display: flex;
  background-color: #3c3c3c;
  height: 30px !important;
  color: #ccc;
}
img {
  height: 28px;
  margin-top: 1px;
}
.bar1 {
  flex-grow: 1;
  display: flex;
}
.dragregion {
  flex-grow: 1;
  text-align: left;
  vertical-align: middle;
  margin: 3px 3px 0px 0px;
  -webkit-app-region: drag;
  display: flex;
  align-items: center;
}
.dragregion > span {
  flex-grow: 1;
  margin-top: -3px;
}
.button {
  width: 44px;
  text-align: center;
  font-size: 12pt;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.button > span {
  flex-grow: 1;
  margin-top: -3px;
  user-select: none;
}
.button:hover {
  background-color: #505050;
}
.close1:hover {
  background-color: red;
  color: white;
}
.button > span.dash {
  vertical-align: sub;
  margin-top: 0px;
}
</style>